import { g as r } from "../internals/global.js";
import { f as n } from "../internals/function-uncurry-this-clause.js";
import { f as e } from "../internals/fails.js";
import { a as i } from "../internals/a-callable.js";
import { a as t } from "../internals/array-sort.js";
import { a as o } from "../internals/array-buffer-view-core.js";
import { e as s } from "../internals/engine-ff-version.js";
import { e as a } from "../internals/engine-is-ie-or-edge.js";
import { e as f } from "../internals/engine-v8-version.js";
import { e as m } from "../internals/engine-webkit-version.js";
var u = o.aTypedArray,
  l = o.exportTypedArrayMethod,
  p = r.Uint16Array,
  c = p && n(p.prototype.sort),
  j = !!c && !(e(function () {
    c(new p(2), null);
  }) && e(function () {
    c(new p(2), {});
  })),
  y = !!c && !e(function () {
    if (f) return f < 74;
    if (s) return s < 67;
    if (a) return !0;
    if (m) return m < 602;
    var r,
      n,
      e = new p(516),
      i = Array(516);
    for (r = 0; r < 516; r++) n = r % 4, e[r] = 515 - r, i[r] = r - 2 * n + 3;
    for (c(e, function (r, n) {
      return (r / 4 | 0) - (n / 4 | 0);
    }), r = 0; r < 516; r++) if (e[r] !== i[r]) return !0;
  });
l("sort", function (r) {
  return (void 0 !== r && i(r), y) ? c(this, r) : t(u(this), function (n, e) {
    return void 0 !== r ? +r(n, e) || 0 : e != e ? -1 : n != n ? 1 : 0 === n && 0 === e ? 1 / n > 0 && 1 / e < 0 ? 1 : -1 : n > e;
  });
}, !y || j);